import React from "react";

// Liens officiels des réseaux sociaux Vytali
export const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/vytali.cartes" },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/VytaliCartes" },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@vytalicartes" },
];

const ICON_PATHS = {
  instagram: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </>
  ),
  facebook: (
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  ),
  tiktok: <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />,
};

const SocialIcon = ({ id, className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {ICON_PATHS[id]}
  </svg>
);

export function SocialLinks({ variant = "footer", className = "" }) {
  const linkClass =
    variant === "header"
      ? "p-2 rounded-full text-[#5C5C5C] hover:text-[#E63946] hover:bg-[#F4EFE6] transition-colors"
      : "w-9 h-9 rounded-full border border-[#E5E0D8] bg-white text-[#5C5C5C] hover:text-[#E63946] hover:border-[#E63946] transition-colors flex items-center justify-center";
  return (
    <div data-testid={`social-links-${variant}`} className={`flex items-center gap-1.5 ${className}`}>
      {SOCIAL_LINKS.map(({ id, label, href }) => (
        <a
          key={id}
          data-testid={`social-link-${variant}-${id}`}
          href={href}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={label}
          title={label}
          className={linkClass}
        >
          <SocialIcon id={id} className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
